import CryptoJS from 'crypto-js';

/**
 * Web Crypto subtle (Flutter InAppWebView 포함).
 * WebView도 window/document를 쓰므로 window.crypto로 접근한다.
 * subtle은 HTTPS·WebView 버전에 따라 없을 수 있어 crypto-js 폴백을 둔다.
 */
export const getWebCryptoSubtle = () => {
  const subtle = typeof window !== 'undefined' ? window.crypto?.subtle : null;
  if (!subtle || typeof subtle.digest !== 'function') {
    return null;
  }
  return subtle;
};

const sha256HexWithSubtle = async (text, subtle) => {
  const bytes = new TextEncoder().encode(text);
  const digest = await subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

const sha256HexWithCryptoJs = (text) => CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex);

/** UTF-8 문자열 SHA-256 hex (서버·타임냥 stop2·물냥불냥 서명과 동일) */
export const sha256Hex = async (text) => {
  const subtle = getWebCryptoSubtle();
  if (subtle) {
    return sha256HexWithSubtle(text, subtle);
  }
  return sha256HexWithCryptoJs(text);
};

export const formatGameCryptoError = (error, fallbackMessage) => {
  const message = error?.message ?? '';
  if (message.includes('digest') || message === 'CRYPTO_SUBTLE_UNAVAILABLE') {
    return '이 환경에서는 게임을 진행할 수 없습니다.';
  }
  return message || fallbackMessage;
};
